import { ContainerPartDTO } from './containerPartDto';

export class ContainerDTO {
  containerId: string;
  containerNumber: string;
  containerName: string;
  containerDescription: string;
  containerTypeName: string;
  containerTypeId: string | null;
  parentContainerId: string | null;
  parentContainerName: string;
  parentContainerType: string;
  isActive: boolean;
  modifiedBy: string | null;
  modifiedDate: string | null;
  childContainers: ContainerDTO[];
  childParts: ContainerPartDTO[];
}
